import { injectable } from "inversify";
import SidebarMenuItemType from "../enums/SidebarMenuItemType";
import SidebarMenuItem from "../models/SidebarMenuItem";
import ISidebarService from "./ISidebarService";
import { ModuleComponentsMap } from "features/shared/router/ModuleComponentsMap";
import { RouteProps } from "react-router-dom";

@injectable()
export default class SidebarService implements ISidebarService {

  resolveCurrentCardId(pathname: string, sidebarMenuItems: SidebarMenuItem[]): string {
    if (!pathname) return "";

    // Normalization - remove trailing slash except for root
    const normalize = (p: string) => p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p;
    const currentPath = normalize(pathname);

    type Candidate = { cardId: string; matchLength: number };
    let best: Candidate | undefined;

    const trySetBest = (cardId: string, routePath?: string) => {
      if (!routePath) return;
      const normalized = normalize(routePath);
      if (normalized === "") return;
      if (currentPath === normalized || currentPath.startsWith(normalized + "/") ) {
        const len = normalized.length;
        if (!best || len > best.matchLength) {
          best = { cardId, matchLength: len };
        }
      }
    };

    for (const item of sidebarMenuItems) {
      // If it directly has its own routePath (Route type), it can be a candidate => cardId is item.id
      trySetBest(item.id, item.routePath);

      // If it has childItems, test their routePath; cardId is then the parent
      if (item.childItems && item.childItems.length > 0) {
        for (const child of item.childItems) {
          trySetBest(item.id, child.routePath);
        }
      }
    }

    return best ? best.cardId : "";
  }

  getMenuItemsToRegistration(sidebarMenuItems: SidebarMenuItem[]): SidebarMenuItem[] {
    let result: SidebarMenuItem[] = [];
    
    for (const item of sidebarMenuItems) {
      if (item.type == SidebarMenuItemType.Route && !result.some(x => x.moduleName == item.moduleName)) {
        result.push(item);
      }
      else if (item.type == SidebarMenuItemType.Collapse && item.childItems) {
        for (const child of item.childItems) {
          if (!result.some(x => x.moduleName == child.moduleName)) {
            result.push(child);
          }
        }
      }
    }
    
    return result;
  }

  getModuleRoutes(menuItems: SidebarMenuItem[]): RouteProps[] {
    const result: RouteProps[] = [];
    const moduleRegistry = ModuleComponentsMap;
    const itemsToRegistration = this.getMenuItemsToRegistration(menuItems);

    for (const item of itemsToRegistration) {
      const route: RouteProps = {
        exact: item.routePath === "/",
        path: item.routePath ?? "",
        component: moduleRegistry[item.moduleName!],
      };
      result.push(route);
    }

    return result;
  }

}
